module.exports = __webpack_public_path__ + "static/img/Huella Ambiental.5119bafb.png";